/**
   * Javascript implementation of debounce method
   *
   * @method debounce
   * @param {function} callback to be executed
   * @param {Int} time to set timeout
   * @return {function} a debounced function
   */
const debounce = function(callback, wait, context = this) {
  let timeout = null;
  let callbackArgs = null;

  const later = () => callback.apply(context, callbackArgs);

  return function() {
    callbackArgs = arguments;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);
  }
};

export default debounce;



// WEBPACK FOOTER //
// ./src/client/utils/debounce.js